import React from "react";
import {
  BaseEdge,
  EdgeLabelRenderer,
  EdgeProps,
  getSmoothStepPath,
} from "reactflow";

const LoopEdge: React.FC<EdgeProps> = ({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  style = {},
  markerEnd,
  data,
}) => {
  const [edgePath, labelX, labelY] = getSmoothStepPath({
    sourceX,
    sourceY,
    sourcePosition,
    targetX,
    targetY,
    targetPosition,
    borderRadius: 30,
  });

  const itemCount = data?.itemCount || 0;

  return (
    <>
      <BaseEdge
        id={id}
        path={edgePath}
        markerEnd={markerEnd}
        style={{
          ...style,
          strokeWidth: 2,
          strokeDasharray: "5,5",
        }}
      />
      {itemCount > 0 && (
        <EdgeLabelRenderer>
          <div
            style={{
              transform: `translate(-50%, -50%) translate(${labelX}px,${labelY}px)`,
            }}
            className="nodrag nopan absolute text-[9px] bg-white px-2 py-0.5 rounded pointer-events-auto shadow-sm text-primaryGreen font-semibold border border-primaryGreen/30"
          >
            {itemCount === 1 ? "1 item" : `${itemCount} items`}
          </div>
        </EdgeLabelRenderer>
      )}
    </>
  );
};

export default LoopEdge;
